import { Stage } from "../display/Stage.js";
import { TabBar } from "../display/TabBar.js";
import { VisualInstrument } from "../display/VisualInstrument.js";
import { Data } from "../model/Data.js";
import { VOMelodyInstrument } from "../model/DataStructure.js";
import { ProgressList } from "../model/ProgressList.js";

export interface InstrumentAppOptions {
    element: HTMLDivElement;
}

export class InstrumentApp {

    private _element: HTMLDivElement;
    private _stage: Stage;
    private _data: Data;
    private _options: InstrumentAppOptions;
    private _audioContext: AudioContext;
    private _current: VisualInstrument = null;
    private _instruments: VisualInstrument[] = [];

    constructor(options: InstrumentAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        try {
            this._stage = new Stage({
                element: this._element,
                className: "instrument-app",
                layout: "responsive"
            });

            new Promise((resolve) => {
                document.addEventListener("click", () => {
                    Tone.start();
                    resolve(true);
                }, { once: true });
            });

            //@ts-ignore
            this._audioContext = Tone.context.rawContext;//new AudioContext();
            Tone.Transport.bpm.value = 120;//Default: 120
            Tone.Transport.start();

            let dataProgress = this._stage.preloader.addProgressList(
                new ProgressList(
                    {
                        label: "Daten"
                    }));

            let audioDownloadProgress = this._stage.preloader.addProgressList(
                new ProgressList(
                    {
                        label: "Audio Download",
                        format: "filesize"
                    }));

            let audioProcessingProgress = this._stage.preloader.addProgressList(
                new ProgressList(
                    {
                        label: "Audio Verarbeitung"
                    }));

            let instrumentDownloadProgress = this._stage.preloader.addProgressList(
                new ProgressList(
                    {
                        label: "Instrumenten Download"
                    }));

            this._data = new Data();

            await this._data.load(this._element.getAttribute("data-data"), dataProgress);
            await this._data.loadMelodyInstrumentsTones(this._audioContext, this._data.data.phil_melody_item, audioDownloadProgress, audioProcessingProgress);
            await this._data.loadMelodyVirtualInstruments(this._data.data.phil_melody_item, instrumentDownloadProgress);

            const bar = new TabBar<VOMelodyInstrument>({
                container: this._stage.foreground,
                direction: "vertical",
                onSelect: (data) => {
                    this.current = data;
                },
            });

            const items = this._data.data.phil_melody_item.slice();
            items.sort((a, b) => a.title.localeCompare(b.title));
            for (let ins of items) {
                bar.add({
                    data: ins,
                    label: ins.title
                })
                var v = new VisualInstrument({
                    container: this._stage.content,
                    instrument: ins,
                    clickable: false,
                    visible: false,
                    showDashes: false
                });
                this._instruments.push(v);
            }


            this.current = items[0];
            bar.current = this.current;

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }

    public get current(): VOMelodyInstrument {
        return this._current?.instrument;
    }
    public set current(v: VOMelodyInstrument) {


        const value = this._instruments.find((va) => va.instrument.id == v.id);

        if (this._current === value) {
            return;
        }

        if (this._current) {
            this._current.visible = false;
            this._current.clickable = false;
        }

        this._current = value;

        if (this._current) {
            this._current.visible = true;
            this._current.clickable = true;
        }
    }
}